export default __webpack_public_path__ + "static/hero-eddfc3d221fe2872507f114bcbf84ec1.png";